const EXPRESS_DELIVERY_VARIANT_ID = 44481925120100;
const EXPRESS_TOGGLE_SELECTOR = '#spoed';

async function submitAtc(event) {
  if (event) {
    event.preventDefault();
  }

  const submitButton = event?.currentTarget || event?.target;
  const originalButtonText = submitButton?.innerText;

  try {
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerText = 'Laden...';
    }

    const shouldAddExpress = isExpressDeliverySelected();
    await syncExpressDeliveryLineItem(shouldAddExpress);
    proceedToCheckout();
  } catch (error) {
    console.error('Error in submitAtc:', error);
  } finally {
    if (submitButton) {
      submitButton.disabled = false;
      if (originalButtonText) {
        submitButton.innerText = originalButtonText;
      }
    }
  }
}

function isExpressDeliverySelected() {
  const expressDeliveryInput = getExpressDeliveryToggle();
  return !!expressDeliveryInput?.checked;
}

async function syncExpressDeliveryLineItem(shouldAddExpress) {
  const cart = await fetchCart();
  const expressItem = cart.items.find(
    (item) => item.variant_id === EXPRESS_DELIVERY_VARIANT_ID
  );

  if (shouldAddExpress && expressItem) {
    updateExpressToggleDataset(true);
    return cart;
  }

  if (!shouldAddExpress && !expressItem) {
    updateExpressToggleDataset(false);
    return cart;
  }

  if (shouldAddExpress) {
    await addExpressDeliveryItem();
    updateExpressToggleDataset(true);
    return fetchCart();
  }

  await updateExpressDeliveryQuantity(expressItem.key, 0);
  updateExpressToggleDataset(false);
  return fetchCart();
}

async function addExpressDeliveryItem() {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: EXPRESS_DELIVERY_VARIANT_ID,
          quantity: 1,
        },
      ],
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to add express delivery item');
  }

  await response.json();
}

async function updateExpressDeliveryQuantity(lineItemKey, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to update express delivery item');
  }

  await response.json();
}

async function fetchCart() {
  const response = await fetch('/cart.js');
  if (!response.ok) {
    throw new Error('Failed to fetch cart');
  }
  return response.json();
}

function updateExpressToggleDataset(state) {
  const expressDeliveryInput = getExpressDeliveryToggle();
  if (expressDeliveryInput) {
    expressDeliveryInput.checked = state;
    expressDeliveryInput.dataset.lastState = state ? 'true' : 'false';
  }
}

function getExpressDeliveryToggle() {
  return document.querySelector(EXPRESS_TOGGLE_SELECTOR);
}

function proceedToCheckout() {
  const checkoutButton =
    document.querySelector('#checkout-button[name="checkout"]') ||
    document.querySelector('#cart button[name="checkout"]') ||
    document.querySelector('button[name="checkout"]');

  if (checkoutButton) {
    checkoutButton.click();
    return;
  }

  const cartForm = document.getElementById('cart');
  if (cartForm) {
    let checkoutInput = cartForm.querySelector('input[name="checkout"]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      cartForm.appendChild(checkoutInput);
    }
    cartForm.submit();
    return;
  }

  window.location.href = '/checkout';
}

function initializeCartHandlers() {
  const form = document.getElementById('cart');
  if (!form) {
    console.error('Cart form not found');
    return;
  }

  const submitButton =
    form.querySelector('[data-express-delivery-submit]') ||
    form.querySelector('button[onclick*="submitAtc"]');
  if (submitButton) {
    submitButton.removeAttribute('onclick');
    submitButton.addEventListener('click', submitAtc);
  }

  bindExpressToggle();
  checkExpressDeliveryInCart();
}

async function checkExpressDeliveryInCart() {
  try {
    const cart = await fetchCart();
    const expressDeliveryInput = document.getElementById('spoed');
    if (!expressDeliveryInput) {
      console.error('Express delivery checkbox not found');
      return;
    }

    const expressDeliveryItem = cart.items.find(
      (item) => item.variant_id === EXPRESS_DELIVERY_VARIANT_ID
    );
    const isExpressInCart = !!expressDeliveryItem;
    updateExpressToggleDataset(isExpressInCart);
  } catch (error) {
    console.error('Error checking cart for express delivery item:', error);
  }
}

function bindExpressToggle() {
  const toggle = getExpressDeliveryToggle();
  if (!toggle) {
    return;
  }

  toggle.addEventListener('change', onExpressToggleChange);
}

async function onExpressToggleChange(event) {
  const toggle = event.target;
  if (!toggle) return;

  const desiredState = toggle.checked;
  const previousStateAttr = toggle.dataset.lastState;
  const previousState = previousStateAttr === undefined ? !desiredState : previousStateAttr === 'true';

  toggle.disabled = true;

  try {
    const updatedCart = await syncExpressDeliveryLineItem(desiredState);
    updateExpressToggleDataset(desiredState);
    if (typeof window.updateCartSummarySection === 'function') {
      window.updateCartSummarySection(updatedCart);
    }
  } catch (error) {
    console.error('Error toggling express delivery:', error);
    toggle.checked = previousState;
    updateExpressToggleDataset(previousState);
  } finally {
    toggle.disabled = false;
  }
}

document.addEventListener('DOMContentLoaded', initializeCartHandlers);
